// Function to handle lazy loading of YouTube player script
function loadYouTubePlayer() {
  const videoPlaceholders = document.querySelectorAll('.video-placeholder');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const videoId = entry.target.getAttribute('data-video-id');
        const script = document.createElement('script');
        script.src = `https://www.youtube.com/s/player/${videoId}/www-embed-player.vflset/www-embed-player.js`;
        script.defer = true;
        document.body.appendChild(script);
        observer.unobserve(entry.target);
      }
    });
  });

  videoPlaceholders.forEach((placeholder) => {
    observer.observe(placeholder);
  });
}

// Call the function to initiate lazy loading
loadYouTubePlayer();
